import { BackgroundColors } from '@strength/domain';

/**
 * Returns a deterministic background color for a cross-team row based on its
 * position in the additional-teams list. Wraps modulo the palette length so
 * any number of teams renders without throwing.
 */
export function getTeamColor(index: number): string {
  const length = BackgroundColors.length;
  // JS modulo preserves sign for negatives — normalize so callers never get a
  // negative index lookup.
  const wrapped = ((index % length) + length) % length;
  // Non-null assertion is safe: `wrapped` is always in [0, length).
  return BackgroundColors[wrapped] as string;
}

/**
 * Convert a 6-digit hex color (e.g. `#F670C7`) to an `rgba()` string with the
 * given alpha. Tolerates a leading `#` and assumes well-formed input — the
 * only callers pass values from `BackgroundColors`.
 */
export function hexWithAlpha(hex: string, alpha: number): string {
  const normalized = hex.startsWith('#') ? hex.slice(1) : hex;
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
